import { Realty, services } from '@ambita/ambita-components-core';
import { ApiSoilContamination } from '../../../typings/CadastreReport';

const util = services.util;

function transformSoilContaminations(soilContaminationData: Realty.ApiResponse) {
  if (soilContaminationData.items && soilContaminationData.items.length > 0) {
    const soilContaminations: ApiSoilContamination[] = soilContaminationData.items;
    const retObject: any = {
      soilContaminations: []
    };

    soilContaminations.forEach((soilContamination: ApiSoilContamination) => {
      const tmpObject: any = util.pick(soilContamination, [
        'authorityType',
        'localityName',
        'degreeOfImpactType',
        'registeredDate',
        'lastUpdatedDate',
        'links'
      ]);

      tmpObject.localityNumber = soilContamination.ident.localityNumber;
      retObject.soilContaminations.push(tmpObject);
    });

    return retObject;
  }
}

export default transformSoilContaminations;
